
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.header {
  margin-left: auto;
  margin-right: auto;
  background-color: var(--gray-professional-lighten-5);
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  padding-left: 1rem;
  padding-right: 1rem;
}@media (min-width: 768px) {.header {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }.header {
    padding-left: 4rem;
    padding-right: 4rem;
  }
}@media (min-width: 1024px) {.header {
    width: 75%;
  }
}.header {
  text-transform: uppercase;
  color: var(--gray-professional-main);
}
.content {
  margin-left: auto;
  margin-right: auto;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
@media (min-width: 768px) {.content {
    flex-direction: row;
  }
}
@media (min-width: 1024px) {.content {
    width: 75%;
  }
}
.description {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--gray-professional-lighten-5);
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
@media (min-width: 768px) {.description {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }.description {
    padding-left: 4rem;
    padding-right: 4rem;
  }
}
.description {
  color: var(--gray-professional-main);
}
@media (min-width: 768px){
  .description{
    width:calc(100% - 20rem);
  }
}
.chart {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: var(--blue-responsible-main);
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  padding-top: 3.5rem;
  padding-bottom: 7rem;
}
@media (min-width: 768px) {.chart {
    width: 20rem;
  }
}
.pie-chart {
  margin-top: 2.25rem;
  margin-bottom: 2.25rem;
}
@media (min-width: 768px) {.pie-chart {
    margin-top: 0px;
    margin-bottom: 0px;
  }
}
`;